var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareerHealthcareCoverage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512.039,
    height: 462.026,
    viewBox: "0 0 512.039 462.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Healthcare_coverage",
    "data-name": "Healthcare coverage",
    transform: "translate(0 -25.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19405",
    "data-name": "Path 19405",
    d: "M255.874,67.5C144.265-30.121,2.356,55.649.029,171.924c-.593,29.633,7.961,58.5,24.988,85.109H135.381l19.63-32.718a15,15,0,0,1,25.517-.335l41.417,65.083,60.373-127.451a15.012,15.012,0,0,1,26.763-.69l51.752,96.111h125.9C579.993,111.273,395.676-54.778,255.874,67.5Z",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19406",
    "data-name": "Path 19406",
    d: "M338.667,279.144l-41.936-77.881-59.3,125.19a15.01,15.01,0,0,1-26.211,1.632l-42.97-67.523L156.736,279.75a15,15,0,0,1-12.862,7.282H48.746c2.982,3.121-12.911-12.74,196.548,195.634a15,15,0,0,0,21.158,0C472.688,277.5,460.024,290.147,463,287.032H351.874a15,15,0,0,1-13.207-7.888Z",
    fill: "#7dbaab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerHealthcareCoverage);
export default __webpack_public_path__ + "static/media/Career-Healthcare-coverage.d5fd17c1f42919dabbf3d448f557b2cf.svg";
export { ForwardRef as ReactComponent };